import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Markdown from "react-markdown";
import RingLoader from "react-spinners/RingLoader";
import { useAuthContext } from '../hooks/useAuthContext';
import remarkGfm from 'remark-gfm'
import { useSubscription } from "../hooks/useSubscription";
import { useContentGeneration } from "../hooks/useContentGeneration";
import validator from "validator";
import languages from "../Templates/Forms/languages";
import { Link } from "react-router-dom";
// import {BiArrowBack} from "react-icons/bi";
import { ToastContainer, toast } from 'react-toastify';
import { AiFillCopy } from "react-icons/ai";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { FaCirclePlay } from "react-icons/fa6";
import { FaLongArrowAltLeft } from "react-icons/fa";
import dayjs from 'dayjs';
import { jwtDecode } from "jwt-decode";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
function CustomFlash() {
  const{subsInfo} = useSubscription()
    const { user ,dispatch} = useAuthContext()
    const [result, setResult] = useState();
    const params = useParams();
    const[show,setShow] = useState(false);
    const [state, setState] = useState({});
    const[documentName,setDocumentName] = useState();

    const[flashDetails,setFlashDetails] = useState("")
    const { sendCustomContentRequest } = useContentGeneration();
    const [copied] = useState("Copy")
    const [isDisabled, setIsDisabled] = useState("");

     const notify = (response) => toast(response);

   const navigate = useNavigate()


const onChange = (e) => {
  const { name, value } = e.target;

  setState({
      ...state,
      documentName:documentName,
      "flash": validator.escape(params.flashName),
      [name]: name === 'output' ? value : e.target.getAttribute('fieldname') + ": " + value
  });
};


console.log(state)
    //fetch custom specific flash name and description
const getSpecificFlash = async() => {
    const response = await fetch(`${process.env.REACT_APP_API_URL || "http://localhost:4000"}/api/flash/specific-custom?slug=${params.flashName}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${user}`
        },
    })

if(response.ok){
    const json = await response.json()
      
       setFlashDetails(json)


    
}
  

}


    //fetch saved history for respective flash only

    // const getHistory = async () => {
    //     const content = await fetchSpecificHistory(params.flashName)
    //     dispatchcontent({ type: 'FETCH_CONTENTS', payload: content })

    // }

    useEffect(() => {
  


        const User = jwtDecode(user)
        const checkToken = async() =>{
          const isExpired = dayjs.unix(User.exp).diff(dayjs())< 1;
        console.log(isExpired)
        if(!isExpired){
              getSpecificFlash()
            // getHistory()
        }else{
          
          const response = await fetch(`${process.env.REACT_APP_API_URL || "http://localhost:4000"}/user/refresh-token`, {
            method: 'GET',
            headers: {'Content-Type':'application/json', 
        }
        })
       
      if(response.status === 200){
        console.log("login")
         const json = await response.json()
         console.log(json)
         dispatch({ type: 'LOGIN', payload: json.token })
         navigate("/")
      }else{
        console.log("logout")
        Cookies.remove("token")
        Cookies.remove("refresh_token")
        dispatch({ type: 'LOGOUT'})
      }
        }
      
      }
        
      
      
      checkToken()

        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [])

 
   

        const handleSubmit = async (e) => {
          e.preventDefault()
          //generate the content and s
          setIsDisabled(true)
          setShow(true)
          // isboolVal(true)
          // alert(boolVal)


          //send it to the page via props
          const content = await sendCustomContentRequest(state)
          if (content.status === 400) {
       
             const json = await content.json()
       setResult(json.error)
              //  props.onSubmit(boolVal,json.error)
          //  if(json.error){
          //   setResult(result.error)

          //  }
              //  setResult(json)
               setIsDisabled(false)
          } else {
              const json = await content.json()

              setResult(json)
              // props.onSubmit(boolVal, json)
              setIsDisabled(false)
  
              
  
  
          }
          setShow(false)
  
  
  
  
      }


    if (user) {
        return (
            <div className="min-h-screen lg:w-3/4 md:w-3/4 sm:w-3/4 w-2/3 mt-4 mx-auto">
                           <div className="flex justify-between ">
                   
                           <Link to="/"><FaLongArrowAltLeft className="text-gray-600 hover:text-black dark:text-white hover:cursor-pointer mb-2"  size={25}/></Link>


    <Link className="flex font-Rajdhani  text-gray-600 no-underline hover:text-black dark:text-white " to="/product-updates">
  <p className="text-md pr-1 ">How to use flashes?</p>
  <FaCirclePlay  className="text-gray-600 dark:text-white" size={20}/>
  </Link>
    


</div>
                <div className="rounded p-4 shadow-xl border-1 font-Rajdhani ">

                       
                <div class="d-flex position-relative align-items-center ">
          <img src="/assets/custom.png" alt="" className=" overflow-hidden w-10 bg-slate-200  rounded-full"/>
         
        </div>
        <h1 className="text-3xl font-medium mt-5">{flashDetails && flashDetails['Flash']['FormName']}</h1>
                <p className="text-xl font-medium dark:text-gray-300">{flashDetails && flashDetails['Flash']['FormTagline']}</p>

        <form onSubmit={handleSubmit} >
        <label  className="font-medium py-2 text-xl">
   Name
</label>
<input type="text" name="documentName" onChange={(e) => setDocumentName(e.target.value)} required placeholder="Give this response a name this will help you find it in the history page" className="dark:bg-[#2c2f44] dark:text-[#99a0ac] border font-normals rounded shadow-sm w-full font-Rajdhani  text-gray-900 outline-none px-3 py-1 focus:outline-none"/><br/>

                {/* <h5 className="dark:text-white text-slate-800 font-Sarabun font-medium  mt-3"></h5> */}
                {flashDetails?.Flash?.fields?.map((t) => {
    const CustomTag = t['type'];
    return (
        <div className="col">
            <label className="font-medium py-2 text-xl">{t['label']}</label>
            <CustomTag 
                className="dark:bg-[#2c2f44] dark:text-[#99a0ac] border font-normal rounded shadow-sm w-full font-Rajdhani text-gray-900 outline-none px-3 py-1 focus:outline-none" 
                name={t['name']} 
        fieldName={t['label']}
                placeholder={t['placeholder']} 
                onChange={onChange}
                required 
            />
        </div>
    );
})}

<div className="flex justify-end">
<div className="flex  items-center">
<p className=" mt-3 font-medium mr-2 ">Outputs</p>
<select name="output"  className="border w-[50px]   mr-2 rounded font-medium p-2 dark:bg-[#818998] dark:text-white dark:bg-none"  onChange={onChange}>
{[1, 2, 3, 4].map(num => (
                            <option key={num} value={num}>{num}</option>
                        ))}
           
                                    </select>
   </div>
                                  <div className="flex  items-center">
                                  <p className=" mt-3 font-medium mr-2 ">Language</p>
                                    <select name="language"  className="border  mr-2 rounded font-medium p-2 dark:bg-[#818998] dark:text-white dark:bg-none"  onChange={onChange}>
                                    {languages.map((lang)=>(
                                       <option value={lang}>{lang}</option>
                                    ))}
                                     
                                    </select>
                                    </div>
                                  
                                    <div>

                                 
                                        <button type="submit" className="btn dark:bg-[#818998] dark:text-white dark:bg-none dark:rounded-2xl  dark:hover:bg-[#818998] dark:hover:text-white text-white  bg-gradient-to-r from-orange-700 to-orange-600 mt-2" disabled={isDisabled}>Generate
                                        </button>
                                        </div>
                                     
                                    </div>
                                    </form>
                                    

{ subsInfo && 

subsInfo.status === "inactive" 

?subsInfo.details.words >=subsInfo.details.totalwords    ?
<div>
<p className="font-Rajdhani text-red-600 dark:text-red-400">Upgrade to premium or wait for a month to continue using flash.</p>


          </div>

: null : null }
                </div>
                <div className="mt-10">
                    <Tabs
                        defaultActiveKey="results"
                        id="fill-tab-example"
                        className="mb-3 font-normal"
                        nav-justified
                        nav-fill
                    >
                        <Tab eventKey="results" title="Results">

                        {result ? (
    Array.isArray(result) ? (
        result.map((result, index) => (
            <div key={index} className="results font-normal border-1 p-4 shadow-sm rounded my-5 heading-sm">
                <p>
                    <Markdown remarkPlugins={[remarkGfm]}>
                        {result}
                    </Markdown>
                </p>
                <CopyToClipboard text={result} onCopy={() => notify("Copied!")}>
                    <span className="flex dark:hover:text-slate-300">
                        <AiFillCopy size={20} className="cursor-pointer dark:hover:text-slate-300" />
                        <p className="cursor-pointer px-1 dark:hover:text-slate-300">{copied}</p>
                    </span>
                </CopyToClipboard>
            </div>
        ))
    ) : (
        // Display the error message if result is not an array
        <div className="error-message">
            <p className="font-Rajdhani">{result}</p>
        </div>
    )
) : (
    <div>
        {/* <BeatLoader visible={show} color="#dd412b" /> */}
        {show === true ? null : <p className="font-Rajdhani text-xl">Generate content now! Visit history to view/edit previously generated content</p>}
        <RingLoader
            loading={show}
            height="80"
            width="80"
            ariaLabel="vortex-loading"
            wrapperClass="vortex-wrapper"
            color="#dd412b"
        />
    </div>
)}

<ToastContainer
                    position="top-right"
                    autoClose={2000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                  />


                        </Tab>

                      
                    </Tabs>
                </div>
            </div>
        )
    }
}
export default CustomFlash;